var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3825 17.8209C23.345 13.7783 26.7932 11.8115 26.9509 11.7199C24.998 8.9567 21.9711 8.57916 20.9074 8.54906C18.3652 8.28941 15.8992 10.0254 14.6042 10.0254C13.2833 10.0254 11.2891 8.57414 9.13975 8.61679C6.37392 8.65818 3.78646 10.2123 2.36735 12.6256C-0.56132 17.5462 1.62291 24.7773 4.4288 28.7547C5.83239 30.7026 7.4725 32.8776 9.61925 32.8011C11.7195 32.717 12.504 31.5016 15.0385 31.5016C17.5497 31.5016 18.2864 32.8011 20.4758 32.7522C22.7298 32.717 24.1489 30.7954 25.5034 28.8299C27.1254 26.5973 27.7768 24.3985 27.8026 24.2856C27.7496 24.268 23.4251 22.6663 23.3825 17.8209Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2466 5.93257C20.3762 4.56161 21.1491 2.69646 20.9346 0.803711C19.2996 0.873952 17.255 1.90123 16.0776 3.24208C15.0359 4.42364 14.1053 6.36029 14.3457 8.18154C16.1823 8.3145 18.0679 7.28221 19.2466 5.93257Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.9b094900e977262f31de5a42ce572778.svg";
export { ForwardRef as ReactComponent };